/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      aria-labelledby={`nav-tab-${index}`}
      component="div"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      role="tabpanel"
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={event => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}));

export default function NavTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const panel = Object.keys(props.items).map(i => (
    <TabPanel index={props.items[i].id} key={props.items[i].id} value={value}>
      {props.items[i].content}
    </TabPanel>
  ));

  const tabs = Object.keys(props.items).map(i => (
    <LinkTab
      key={props.items[i].id}
      label={props.items[i].label}
      {...a11yProps(props.items[i].id)}
    />
  ));
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          aria-label="nav tabs example"
          indicatorColor={props.indicatorColor}
          onChange={handleChange}
          value={value}
          variant="fullWidth"
        >
          {tabs}
        </Tabs>
      </AppBar>
      {panel}
    </div>
  );
}
